import { render, staticRenderFns } from "./TwImagePasteAndUploadDialog.vue?vue&type=template&id=2a5bf2b6&"
import script from "./TwImagePasteAndUploadDialog.vue?vue&type=script&lang=js&"
export * from "./TwImagePasteAndUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./TwImagePasteAndUploadDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports